import viMessages from '../locales/vi_VN';

const ViLang = {
  messages: {
    ...viMessages
  },
  locale: 'vi-VN'
};
export default ViLang;
